/**
 * GenerateQRCode Component
 * 
 * https://github.com/gcoro/react-qrcode-logo
 * 
 * A wrapper around `react-qrcode-logo`for generating styled QR codes with an embedded logo.
 * 
 * Features:
 * - Supports custom size, colors, and "dots" style QR rendering.
 * - Embeds a default logo (`qrLogo.svg`) in the center.
 * - Provides eye customization (radius + color).
 *
 * @param {string} value - The text/URL/data string to encode into the QR code.
 */

import QRCode from "react-qrcode-logo";

const qrLogo = '/images/settings/qrLogo.svg';

const GenerateQRCode = ({value}:{value: string}) => {

  return (
     <>
          <QRCode 
            value={value}
            size={100}
            quietZone={0}
            bgColor={`white`}
            fgColor={`#000000`}
            eyeRadius={{ outer: 7, inner: 2}}
            eyeColor={`#000000`}
            qrStyle="dots"
            logoImage={qrLogo}
            removeQrCodeBehindLogo={true}
             />
     </>
  )
}


export default GenerateQRCode;